import React from 'react'

import { Form as FinalForm } from 'react-final-form'
import { withRouter } from 'react-router-dom'

import Form from './index.presentational'

import {
  ContainerProps,
  FinalFormApi,
} from './types'

const FormContainer: React.FC<ContainerProps> = ({
  history,
  nextUrl,
  onSubmit: onSubmitProp,
  ...props
}): React.ReactElement => {
  return React.createElement(
    FinalForm,
    {
      keepDirtyOnReinitialize: true,
      onSubmit: () => {
        if (nextUrl) {
          const uri = (nextUrl && `/${nextUrl.replace(/^\//, '')}`) || '/'

          history.push(uri)
        }
      },
      ...props,
    },
    ({
      form: finalFormApi,
      handleSubmit,
    }: {
      form: FinalFormApi,
      handleSubmit(event?: React.FormEvent): void,
    }) => {
      return React.createElement(Form, {
        finalFormApi,
        ...props,
        onSubmit: event => {
          const firstInvalidField = finalFormApi.getRegisteredFields().find((field: string) => finalFormApi.getFieldState(field).invalid)

          if (firstInvalidField) {
            const targetInput = document.querySelector(`[name="${firstInvalidField}"]`) as HTMLElement
            const targetLabel = document.querySelector(`label[for="${firstInvalidField}"]`) as HTMLElement || targetInput
            if (targetInput) {
              targetInput.focus({ preventScroll: true })
              targetLabel.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }

          const { valid } = finalFormApi.getState()
          valid && onSubmitProp && onSubmitProp(event)

          handleSubmit(event)
        },
      })
    },
  )
}

export * from './types'

export default withRouter(FormContainer)
